const isWholeNumber = (num) => num % 1 === 0;

export const splitPercentageToNumber = (splitPercentage /*: string */) => {
  return Number(splitPercentage) / 100;
};

export const splitPercentageToString = (
  splitPercentage /*: number */,
  precision /*: number */ = 0,
) => {
  const val = splitPercentage * 100;
  return isWholeNumber(val)
    ? val.toString()
    : (+(splitPercentage * 100).toFixed(precision)).toString();
};

export const splitGroupsToNodeData = (splitGroups) =>
  splitGroups.reduce((acc, curr) => {
    if (curr.splitPercentage === '0') return acc; // remove any splitGroups with a value of 0
    return [...acc, { splitPercentage: splitPercentageToNumber(curr.splitPercentage) }];
  }, []);

export const validSplitGroups = (splitGroups) => {
  const total = +splitGroups
    .reduce((acc, curr) => acc + Number(curr.splitPercentage), 0)
    .toFixed(2);
  return total >= 99.9 && total <= 100;
};

export const isValidSplitPercentage = (str) => /^(\d)*(\.)?([0-9]{0,2})$/.test(str);
